import firebase from 'firebase/app'

const config = {
  apiKey: 'AIzaSyDRgcLv6tbMHDdV5Wyo1i-EJshNPSrTzmA',
  authDomain: 'town-portal-5c0fc.firebaseapp.com',
  databaseURL: 'https://town-portal-5c0fc.firebaseio.com',
  projectId: 'town-portal-5c0fc',
  storageBucket: 'town-portal-5c0fc.appspot.com',
  messagingSenderId: '899041326187',
}

export function initializeFirebase() {
  firebase.initializeApp(config)
}



// WEBPACK FOOTER //
// ./src/modules/firebase.js